import { CHART_NOTES_VISIT_TYPE } from "constants/chart-notes";
import { type Appointment } from "services/types/appointments.type";
import { type ChartNote } from "services/types/chart-notes.type";

import {
  type LastUserChartNotesByType,
  type MergeTagsDataSource
} from "./merge-tags-data-source.type";

// ENG-2484: the merge-tag data source for someone who may not see visit notes. Every visit note's
// text is blanked (an appointment's chart note is always its visit note), so the chart-note merge
// tags resolve to empty instead of printing the note into a letter, email or form. Blanked rather
// than removed so "My Last Chart Note (visit)" does not fall back to an unrelated note.
export function withoutVisitNoteText(
  source: MergeTagsDataSource
): MergeTagsDataSource {
  return {
    ...source,
    currentAppointment: withoutChartNoteText(source.currentAppointment),
    nextAppointment: withoutChartNoteText(source.nextAppointment),
    lastAppointment: withoutChartNoteText(source.lastAppointment),
    boundAppointment: withoutChartNoteText(source.boundAppointment),
    lastUserChartNoteByType: withoutVisitNotesByType(
      source.lastUserChartNoteByType
    )
  };
}

function withoutChartNoteText(
  appointment: Appointment | undefined
): Appointment | undefined {
  if (!appointment?.chartNote) return appointment;
  return { ...appointment, chartNote: { ...appointment.chartNote, text: "" } };
}

function withoutVisitNotesByType(
  byType: LastUserChartNotesByType | undefined
): LastUserChartNotesByType | undefined {
  if (!byType) return byType;
  return {
    ...byType,
    visit: blankText(byType.visit),
    any:
      byType.any?.type === CHART_NOTES_VISIT_TYPE
        ? blankText(byType.any)
        : byType.any
  };
}

function blankText(
  note: ChartNote | null | undefined
): ChartNote | null | undefined {
  return note ? { ...note, text: "" } : note;
}
